import styled from 'styled-components';

import { RadiusConfig } from 'enable-ui';

import { COLOR, COLOR_CONFIG } from 'constants/color';

export const CustomTable = styled.div<{ $isShowBorder?: boolean }>`
  width: 100%;
  overflow-x: auto;
  border-radius: 12px;
  padding: 16px;
  border: ${(props) =>
    props.$isShowBorder === false ? 'none' : `1px solid ${COLOR.neutralTrans['neutralTrans-15']}`};

  .table-levels-lessons-wrapper .es-table-wrapper {
    padding: 16px;
  }

  .table-levels-lessons-wrapper .es-table-wrapper tbody tr:last-child {
    border-bottom: unset;
  }

  .active a {
    background: #fd8a241a;
    color: ${COLOR.primary['primary-6']};
  }
  .next {
    svg path {
      stroke: ${COLOR_CONFIG['neutral-text']};
    }
    button {
      background-color: transparent;
    }
  }
  .previous {
    svg path {
      stroke: ${COLOR_CONFIG['neutral-text']};
    }
    button {
      background-color: transparent;
    }
  }
  .disabled {
    svg path {
      stroke: ${COLOR.neutralTrans['neutralTrans-25']};
    }
  }
  .page-item a {
    font-size: 16px;
    line-height: calc(22 / 16);
    font-weight: 600;
    padding: 0px 12px;
    border-radius: ${RadiusConfig.sm}px;
    margin-right: 0;
  }
  .page-item:not(.active) a {
    color: ${COLOR_CONFIG['neutral-text']};
  }

  thead {
    tr {
      background: #f5f5f5 !important;
      border-bottom: none;

      th {
        p {
          font-size: 14px;
          font-weight: 600;
          line-height: 20px;
          color: ${COLOR_CONFIG['neutral-text']};
          white-space: nowrap;
        }
      }
    }
  }

  th,
  td {
    padding: 12px 16px;

    &:first-child {
      border-top-left-radius: 12px;
      border-bottom-left-radius: 12px;
    }

    &:last-child {
      border-top-right-radius: 12px;
      border-bottom-right-radius: 12px;
    }
  }

  tr {
    &:hover {
      background: #0000000f !important;
    }
  }

  tr:nth-child(even) {
    background: ${COLOR_CONFIG.doctor};
  }

  tr:nth-child(odd) {
    background: ${COLOR_CONFIG.white};
  }

  tbody {
    td {
      p {
        font-size: 16px;
        font-weight: 400;
        line-height: 26px;
        color: ${COLOR.surfaceNeutralBold['neutral-11']};
      }
    }
  }

  .es-paginate-info {
    p {
      font-size: 16px;
      line-height: calc(22 / 16);
      color: ${COLOR_CONFIG['neutral-text']};
    }
  }

  .dropdown {
    .dropdown-item {
      background: ${COLOR_CONFIG.white};

      &:hover {
        background: ${COLOR.neutral['neutral-2']};
      }
    }
  }

  .dropdown-children {
    div {
      padding: 5px 12px;
      border-radius: ${RadiusConfig.sm}px;
      gap: 2px;
      max-width: 111px;
      width: 100% !important;
      justify-content: normal;
      background-color: ${COLOR_CONFIG.white};
    }

    p {
      font-size: 16px;
      line-height: calc(22 / 16);
      color: ${COLOR.surfaceNeutralBold['neutral-11']};
    }

    .icon {
      padding: 0 !important;
    }
  }

  .pagination-container {
    margin: 16px 16px 0 0;
  }

  .paginate-navigation {
    margin: 0;
  }
`;
